/**
 * Util to check if CDN media is available.
 * @param mediaUrl Media URL for asset.
 */
export const isCdnMediaAvailable = async (httpClient, mediaUrl) => {
    try {
        const headResponse = await httpClient.head(mediaUrl);
        return headResponse === 200;
    }
    catch (e) {
        return false;
    }
};
//# sourceMappingURL=is-cdn-media-available.js.map